import { Copy, Eye, EyeOff, RotateCcw } from 'lucide-react';
import { useState } from 'react';

import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from '@/components/shadcn/ui/input-group';
import { Label } from '@/components/shadcn/ui/label';
import { Switch } from '@/components/shadcn/ui/switch';
import { toast } from '@/stores/pure/ToastStore';
import { clipboardCopy } from '@/utils/util';

import { useSharedLinkUpdate } from '../hooks';
import { useSharedLinkForm } from './shared-link-form-context';

export function PasswordSettings() {
  const form = useSharedLinkForm();
  const [showPassword, setShowPassword] = useState(false);
  const { saveChanges } = useSharedLinkUpdate(form);

  const refreshPassword = () => {
    const newPasssword = Math.random().toString(36).substring(2, 12);
    form.setFieldValue('password', newPasssword);
    saveChanges();
  };

  const handleCopy = (password: string) => {
    clipboardCopy(password);
    toast('Password copied to clipboard', 'success');
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <Label className="text-sm font-medium text-gray-900">
          Password protection
        </Label>
        <form.AppField
          name="passwordEnabled"
          children={(field: any) => (
            <Switch
              checked={field.state.value ?? false}
              onCheckedChange={(checked) => {
                field.handleChange(checked);
                saveChanges();
              }}
            />
          )}
        />
      </div>

      <form.AppField
        name="passwordEnabled"
        children={(enabledField: any) =>
          enabledField.state.value && (
            <form.AppField
              name="password"
              children={(field: any) => (
                <InputGroup>
                  <InputGroupAddon
                    className="text-foreground cursor-pointer"
                    align="inline-start"
                    onClick={() => setShowPassword(!showPassword)}
                    role="button"
                  >
                    {showPassword ? <Eye /> : <EyeOff />}
                  </InputGroupAddon>
                  <InputGroupInput
                    type={showPassword ? 'text' : 'password'}
                    value={field.state.value ?? ''}
                    readOnly
                  />

                  <InputGroupAddon
                    className="text-foreground cursor-pointer pr-2"
                    align="inline-end"
                    onClick={refreshPassword}
                    role="button"
                  >
                    <RotateCcw />
                  </InputGroupAddon>
                  <InputGroupAddon
                    className="text-foreground cursor-pointer"
                    align="inline-end"
                    onClick={() => handleCopy(field.state.value ?? '')}
                    role="button"
                  >
                    <Copy />
                  </InputGroupAddon>
                </InputGroup>
              )}
            />
          )
        }
      />
    </div>
  );
}
